import React from 'react';
import { Box, List, ListItemButton, ListItemText } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

const Menu: React.FC = () => {
  const navigate = useNavigate();
  const { isLoggedIn, logout } = useAuth();

  const menuItems = [
    { label: 'Home', path: '/' },
    { label: 'Pilates Session', path: '/session' },
    { label: 'About & Plans', path: '/about' },
    { label: 'Card Sequences', path: '/cards' },
    { label: 'My Page', path: '/mypage' },
    { label: 'Booking', path: '/booking' },
    { label: 'News', path: '/news' },
    { label: 'Community Talk', path: '/community' },
    { label: 'Q & A', path: '/qa' },
    { label: 'Contact', path: '/contact' },

    // 👇 dynamic login/logout
    !isLoggedIn
      ? { label: 'Login', path: '/login' }
      : { label: 'Logout', path: '/' },
  ].filter(Boolean);

  const handleClick = (item: any) => {
    if (item.label === 'Logout') {
      logout();
      navigate('/');
    } else {
      navigate(item.path);
    }
  };

  return (
    <Box>
      <List>
        {menuItems.map((item) => (
          <ListItemButton key={item.label} onClick={() => handleClick(item)}>
            <ListItemText
              primary={item.label}
              sx={{ '& .MuiListItemText-primary': { fontWeight: 500 } }}
            />
          </ListItemButton>
        ))}
      </List>
    </Box>
  );
};

export default Menu;